//==================================================================//
//======================= IMPORTS API ==============================//
//==================================================================//

import ERP from "../ERP.mjs";
import View from "../View.mjs";
import Schema from "../Schema.mjs";

import UtilDateTime from "@/utils/UtilDateTime";

//==================================================================//
//========================= METHODS ================================//
//==================================================================//

export default {

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewJobs(){

        let jobs;

        try{

            //==================================================================//
            //========================= Pega Jobs ==============================//
            //==================================================================//

            jobs = await ERP.getManyWithView(View.JOB_FINALIZAR);

        }catch(e){

            console.log(e);
            return jobs;

        }

        return jobs;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async pegaViewValidacaoDoJob(jobID = ""){

        let validacaoDoJob;

        try{

            //==================================================================//
            //============== PEGA OS DADOS DE VALIDAÇÃO DO JOB ==================//
            //==================================================================//

            validacaoDoJob = await ERP.getOneWithView(View.JOB_FINALIZAR_VALIDA_JOB,[
                {
                    name: "job",
                    dataType: "String",
                    value: jobID
                },
            ]);

        }catch(e){

            console.log(e);
            return validacaoDoJob;

        }

        return validacaoDoJob;

    },

    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//
    //*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=//

    async finalizaJob(jobID = ""){

        let jobFinalizado;

        try{

            //==================================================================//
            //===================== FINALIZA O JOB ==============================//
            //==================================================================//

            jobFinalizado = await ERP.patchOne(Schema.JOB, {
                id: jobID,
                status: "Finalizado",
                dataEncerramento: UtilDateTime.nowUTC(),
            });

            if(jobFinalizado?.status != 200){
                throw jobFinalizado;
            }

        }catch(e){

            console.log(e);
            return jobFinalizado;

        }

        return jobFinalizado;

    },

}
